const datesArray = ["א", "ב", "ג", "ד", "ה", "ו","ש"]

export {datesArray}